import {
  faLock,
  faMinus,
  faPlus,
  faSpinnerThird,
} from "@fortawesome/pro-regular-svg-icons";
import { faHome } from "@fortawesome/pro-solid-svg-icons";
import { Typography } from "@mui/material";

import { Workspace } from "@/components/graphql/schema.graphql";
import type { WorkspaceDropdownInfo } from "@/components/nav/components/PrimaryNavigation/components/PrimaryNavigationContent/components/PrimaryNavigationHeader/components/WorkspaceDropdown/types";
import { WorkspaceAvatar } from "@/components/nav/components/PrimaryNavigation/components/PrimaryNavigationContent/components/PrimaryNavigationHeader/components/WorkspaceDropdown/WorkspaceDropdown";

import { Icon } from "../Icon/Icon";
import { MenuItem } from "../Menu/components/MenuItem";

interface WorkspaceMenuItemProps {
  workspace: Pick<
    Workspace,
    | "id"
    | "name"
    | "displayName"
    | "profilePicture"
    | "planTier"
    | "myPermissions"
  >;
  objectOwnerWorkspaceId: string;
  isImported: boolean;
  allowImport: boolean;
  onImport: (workspaceId: string) => void;
  onUnimport: (workspaceId: string) => void;
  isLoading?: boolean;
}

export const WorkspaceMenuItem = (props: WorkspaceMenuItemProps) => {
  const {
    workspace,
    objectOwnerWorkspaceId,
    isImported,
    allowImport,
    onImport,
    onUnimport,
    isLoading,
  } = props;

  const isOwnerWorkspace = workspace.id === objectOwnerWorkspaceId;

  const getEndIcon = () => {
    if (isOwnerWorkspace) {
      return <Icon icon={faHome} style={{ marginRight: "4px" }} />;
    }
    if (!allowImport) {
      return <Icon icon={faLock} style={{ marginRight: "4px" }} />;
    }
    if (isLoading) {
      return <Icon icon={faSpinnerThird} spin style={{ marginRight: "4px" }} />;
    }

    if (isImported) {
      return (
        <Icon
          data-testid="remove-style-workspaces-button"
          icon={faMinus}
          style={{ marginRight: "4px" }}
        />
      );
    }

    return (
      <Icon
        data-testid="add-style-workspaces-button"
        icon={faPlus}
        style={{ marginRight: "4px" }}
      />
    );
  };

  const endIcon = getEndIcon();

  const onClick = () => {
    if (isImported) {
      onUnimport(workspace.id);
    } else {
      onImport(workspace.id);
    }
  };

  return (
    <MenuItem
      onClick={onClick}
      disabled={!allowImport || isLoading || isOwnerWorkspace}
      endIcon={endIcon}
      sx={{
        "& .MuiListItemText-primary": {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
          justifyContent: "flex-start",
        },
      }}
    >
      <WorkspaceAvatar
        isLink={false}
        workspace={workspace as WorkspaceDropdownInfo}
        sx={{
          width: 20,
          height: 20,
        }}
        disableTooltip
      />
      <Typography variant="small">{workspace.displayName}</Typography>
    </MenuItem>
  );
};
